import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

// ─── Tailwind class merger ────────────────────────────────────────────────────
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// ─── Date formatter ───────────────────────────────────────────────────────────
export function formatDate(date: string | Date | undefined): string {
  if (!date) return '—'
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

// ─── Country flag emojis ──────────────────────────────────────────────────────
export const COUNTRY_FLAGS: Record<string, string> = {
  ng: '🇳🇬', gh: '🇬🇭', ke: '🇰🇪', za: '🇿🇦', tz: '🇹🇿', ug: '🇺🇬', sn: '🇸🇳', cm: '🇨🇲',
  us: '🇺🇸', gb: '🇬🇧', ca: '🇨🇦', au: '🇦🇺', de: '🇩🇪', fr: '🇫🇷', es: '🇪🇸', it: '🇮🇹',
  br: '🇧🇷', ar: '🇦🇷', mx: '🇲🇽', pt: '🇵🇹', nl: '🇳🇱', be: '🇧🇪', se: '🇸🇪', no: '🇳🇴',
  dk: '🇩🇰', fi: '🇫🇮', pl: '🇵🇱', cz: '🇨🇿', hr: '🇭🇷', gr: '🇬🇷', tr: '🇹🇷', ru: '🇷🇺',
  cn: '🇨🇳', jp: '🇯🇵', kr: '🇰🇷', in: '🇮🇳', id: '🇮🇩', th: '🇹🇭', vn: '🇻🇳', my: '🇲🇾',
  ph: '🇵🇭', sg: '🇸🇬', eg: '🇪🇬', ma: '🇲🇦', tn: '🇹🇳', dz: '🇩🇿', et: '🇪🇹',
}


